import clsx from 'clsx'

export function PillToggle({
  checked,
  onChange,
  label,
  count,
  id,
  className,
}: {
  checked: boolean
  onChange: (v: boolean) => void
  label: string
  count?: number
  id?: string
  className?: string
}) {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={clsx('stryzh-pill-toggle', checked && 'stryzh-pill-toggle--on', className)}
    >
      <span className="stryzh-pill-toggle__track" aria-hidden>
        <span className="stryzh-pill-toggle__knob" />
      </span>
      <span className="stryzh-pill-toggle__label">
        {label}
        {count != null ? (
          <span className="stryzh-pill-toggle__count" aria-label={`(${count})`}>
            {count}
          </span>
        ) : null}
      </span>
    </button>
  )
}
